<template>
  <div>
    <div class="left-aside">
      <div id="registrationForm" class="registration-form">
        <div class="brand">
          <router-link to="/Login"><img :src="require('@/assets/img/logo-management.svg')" alt=""></router-link>
        </div>

        <div class="hero-txt register">
          <div v-if="errMsg.message">
            <div class="error-message">
              <!-- <img src="https://halcyon-api-files.s3-ap-southeast-1.amazonaws.com/cloud-assets/icon-error-mismatch.svg"> -->
              {{ errMsg.message }}
            </div>
          </div>
          <div v-if="sendSuccessMessage">
            <div class="primary-message alert alert-primary">{{ sendSuccessMessage }}</div>
          </div>
          <h2>Step {{ step }}</h2>
          <span>{{ stepMessage }}</span>
        </div>
        <form>
          <div v-if="step == 1">
            <div class="form-group">
              <label for="">Last name</label>
              <input type="text" class="form-control" v-model="registration.lastName" v-to-camelcase maxlength="32" placeholder="">
            </div>
            <div class="form-group">
              <label for="">First name</label>
              <input type="text" class="form-control" v-model="registration.firstName" v-to-camelcase maxlength="32" placeholder="">
            </div>
            <div class="form-group">
              <label for="">Email</label>
              <input type="text" class="form-control" v-model="registration.email" @input="camelCaseAndSpace('email')" placeholder="">
            </div>
            <div class="form-group">
              <label for="">Organization</label>
              <div class="input-boxes">
                <textarea cols="10" rows="4" class="form-control" v-model="registration.organization" minlength="6" maxlength="100"></textarea>
                <b-button id="tooltip-target-organization" class="btn-tool-tip tool-tip-registration">
                  <span><img :src="assets + 'icon-info.svg'"></span>
                </b-button>
                <b-tooltip v-if="organizationToolTip" target="tooltip-target-organization" triggers="hover">
                  {{ organizationToolTip }}
                </b-tooltip>
              </div>
            </div>
          </div>
          <div v-if="step == 2">
            <div class="form-group form-confirmation">
              <span>Please check your email: <strong>{{ registration.email }}</strong><br>for your valid code.</span>
            </div>
            <br clesr="all">
            <div class="form-group">
              <label for="">Registration Code</label>
              <input type="text" class="form-control text-center" v-model="registration.code" maxlength="6" placeholder="">
            </div>
          </div>

          <div v-if="step == 3">
            <div class="form-group">
              <label for="">Username</label>
              <div class="input-boxes">
                <input type="text" class="form-control input-username" v-model="registration.username" v-generics maxlength="32" placeholder="">
                <b-button id="tooltip-target-1" class="btn-tool-tip">
                  <span><img :src="assets + 'icon-info.svg'"></span>
                </b-button>
                <b-tooltip v-if="usernameToolTip" target="tooltip-target-1" triggers="hover">
                  {{ usernameToolTip }}
                </b-tooltip>
              </div>
            </div>
            <div class="form-group">
              <label for="">Password</label>
              <input type="password" class="form-control" v-model="registration.password" maxlength="32" placeholder="">
            </div>
            <div class="form-group">
              <label for="">Confirm Password</label>
              <input type="password" class="form-control" v-model="registration.confirmPassword" maxlength="32" placeholder="">
            </div>
            <div class="form-group">
              <input type="checkbox" v-model="terms" class="ck-box">
              <span>Accept terms and conditions here...</span>
            </div>
          </div>
          <button type="button" class="btn btn-lg btn-primary btn-block button-validation" @click="registrationValidation" :disabled="!terms">{{ continueBtn }}</button>
          <button v-if="step > 1" type="button" class="btn btn-lg btn-default btn-block mb-2" @click="backButton">Back</button>
          <div class="txt-center">
            <p v-if="step == 2">
              <span>Didn't receive a code? <a href="javascript:void(0)" @click="sendRegistrationValidation(true)">Send a new one.</a></span>
            </p>
            <span class="txt-center">Already have an account? <router-link to="/Login">Sign in</router-link></span>
          </div>
        </form>
      </div>
    </div>
    <div class="right-aside">
      <img :src="assets + 'register-gfx.jpg'" alt="" class="img-fluid">
    </div>
  </div>
</template>

<script>
import * as dictionary from '@/utils/data-dictionary';
import * as http from '@/utils/http';

export default {
  name: "Registration",
  data() {
    return {
      assets: process.env.VUE_APP_ASSETS,
      continueBtn: 'Next',
      step: 1,
      stepMessage: 'Quick registration to get the work started',
      registration: {
        // lastName : 'Sillador',
        // firstName : 'Rhaynel',
        // email : 'rhaynel.samar.sillador@gmail.com',
        // organization : 'Rhaynel Org',
      },
      terms: true,
      errMsg: {},
      isSubmit: false,
      sendSuccessMessage: "",
      usernameToolTip: 'Usernames must be at least 5 characters long and can only contain alphanumeric characters (A–Z, 0–9) and periods ("."). It must not contain generic terms or extensions (.com, .net).',
      organizationToolTip: 'Organization must contain at least 6 characters long.'
    }
  },
  methods: {
    registrationValidation() {
      this.sendSuccessMessage = "";
      if (this.step == 1) {
        this.terms = true
        if (!dictionary.isLastName(this.registration.lastName) || dictionary.hasSpecialCharacter(this.registration.lastName) || dictionary.hasNumber(this.registration.lastName) || !dictionary.pureSpace(this.registration.lastName) || dictionary.spaceBeforeText(this.registration.lastName)) {
          this.errMsg = { field: "lastName", message: "Please enter valid last name." };
        } else if (!dictionary.isFirstName(this.registration.firstName) || dictionary.hasSpecialCharacter(this.registration.firstName) || dictionary.hasNumber(this.registration.firstName) || !dictionary.pureSpace(this.registration.firstName) || dictionary.spaceBeforeText(this.registration.firstName)) {
          this.errMsg = { field: "firstName", message: "Please enter valid first name." };
        } else if (!dictionary.isNullOrEmpty(this.registration.email)) {
          this.errMsg = { field: "email", message: "Please enter valid email address." };
        } else if (!dictionary.isEmail(this.registration.email)) {
          this.errMsg = { field: "email", message: "Please enter valid email address." };
        } else {
          if (!this.isSubmit) {
            this.isSubmit = true;
            var params = {
              email: this.registration.email,
              main: true
            };
            http.post("/Api/User/CheckEmail", params, (response) => {
              this.isSubmit = false;
              if (response.data.isExist == true) {
                this.errMsg = { field: "email", message: "The email address you entered is already associated with an account." };
              } else {
                if (!dictionary.isOrganization(this.registration.organization) || dictionary.spaceBeforeText(this.registration.organization)) {
                  this.errMsg = { field: "organization", message: "Please enter valid organization." };
                } else {
                  this.errMsg = {};
                  this.sendRegistrationValidation(false);
                }
              }
            })
          }
        }
      } else if (this.step == 2) {
        if (!dictionary.isCode(this.registration.code)) {
          this.errMsg = { field: "code", message: "Please enter valid registration code." };
        } else {
          this.errMsg = {};
          this.sendCodeValidation();
        }
      } else if (this.step == 3) {
        if (!dictionary.isUsername(this.registration.username)) {
          this.errMsg = { field: "username", message: "Please enter valid username." };
        } else if (dictionary.spaceBeforeText(this.registration.username) || dictionary.hasSpecialCharacterExceptPeriod(this.registration.username) || dictionary.checkifHasComAndNet(this.registration.username) || dictionary.spacebetweenText(this.registration.username)) {
          this.errMsg = { field: "username", message: "Please enter valid username." };
        } else if (!dictionary.isPassword(this.registration.password) && !dictionary.isPassword(this.registration.confirmPassword)) {
          this.errMsg = { field: "password", message: "Please enter valid password." };
        } else if (!dictionary.isConfirmPassword(this.registration.password, this.registration.confirmPassword)) {
          this.errMsg = { field: "confirmPassword", message: "Password and Confirm Password does not match." };
        } else if (!this.terms) {
          this.errMsg = { field: "terms", message: "You need to accept terms and condition before proceeding." };
        } else {
          var params = {
            username: this.registration.username,
            main: true
          };
          http.post("/Api/User/CheckUsername", params, (response) => {
            if (response.data.isExist == true) {
              this.errMsg = { field: "email", message: "Username already exist." };
            } else {
              this.errMsg = {};
              this.sendRegistration();
            }
          })
        }
      }
    },
    sendRegistrationValidation(sendVerficationCode) {
      if (!this.isSubmit) {
        this.isSubmit = true;
        this.continueBtn = "Validating"
        http.post('/Api/Generate/Code', { type: "Registration", email: this.registration.email }, (response) => {
          this.isSubmit = false;
          this.terms = true;
          if (response.data.status == "OK") {
            this.step = 2;
            this.continueBtn = "Validate Registration Code";
            if (sendVerficationCode == true) {
              this.errMsg = {};
              this.sendSuccessMessage = 'Verification Code has been sent. Please check your email and enter the correct code.';
            }
          } else {
            this.terms = true;
            this.continueBtn = "Next";
            this.errMsg = response.data;
          }
        })
      }
    },
    sendCodeValidation() {
      if (!this.isSubmit) {
        this.isSubmit = true;
        this.continueBtn = "Validating Registration Code";
        http.post('/Api/Verify/Code', { type: "Registration", email: this.registration.email, code: this.registration.code }, (response) => {
          // http.post('/Api/Registration/Validate/Code', {code :this.registration.code, email : this.registration.email}, (response) => {
          this.isSubmit = false;
          var data = response.data;
          if (data.status == "OK") {
            this.step = 3;
            this.terms = false;
            this.continueBtn = "Register Now";
          } else {
            this.terms = true;
            this.errMsg = { field: "code", message: response.data.message };
            this.continueBtn = "Validate Registration Code";
          }
        })
      }
    },
    sendRegistration() {
      http.post('/Api/Registration', this.registration, (response) => {
        this.login(response.data);
      })
    },
    login(data) {
      http.post("/Api/Login", { username: this.registration.email, password: this.registration.password, type: "ROOT" }, (response) => {
        this.$insProgress.finish();
        // setTimeout(() => {
        //   location.href = "/Authenticating"+http.objectToQuerystring(response.data)
        // }, 500)
        this.$router.push({ name: "LoginSuccess", params: response.data });
      })
    },
    backButton() {
      this.errMsg = {};
      this.sendSuccessMessage = "";
      this.step--;
      if (this.step == 1) {
        this.registration.code = null;
        this.continueBtn = "Next";
      } else if (this.step == 2) {
        this.continueBtn = "Validate Registration Code";
        this.registration.code = null;
        this.registration.username = null;
        this.registration.password = null;
        this.registration.confirmPassword = null;
        this.terms = true;
      }
    },
    camelCaseAndSpace(str) {
      if (str == "email") {
        this.registration.email = this.registration.email.replace(/\s+/g, " ")
        if (this.registration.email.charAt(0) == " ") {
          this.registration.email = this.registration.email.substr(1);
        }
      } if (str == "username") {
        this.registration.username = this.registration.username.replace(/\s+/g, " ")
        if (this.registration.username.charAt(0) == " ") {
          this.registration.username = this.registration.username.substr(1);
        }
      }
    },
  }
}
</script>
